import { useMemo } from 'react';
import { useUserAccess } from '../context/UserAccessContext';
import { useCompaniesOptional } from '../context/CompanyContext';

export function useCrmMailQuota() {
  const { user } = useUserAccess();
  const companyCx = useCompaniesOptional();
  const isAdmin = user?.permission === 'admin';

  const activeCompany = useMemo(() => {
    const list = companyCx?.companies ?? [];
    const id = String(companyCx?.activeCompanyId ?? '');
    return list.find((c) => String(c._id || c.id) === id) ?? null;
  }, [companyCx?.companies, companyCx?.activeCompanyId]);

  const mailRemaining = isAdmin
    ? null
    : Math.max(0, Number(activeCompany?.quotaMail ?? 0));

  const quotaExhausted = mailRemaining !== null && mailRemaining <= 0;
  const canSendMail = isAdmin || !quotaExhausted;

  return {
    isAdmin,
    activeCompany,
    mailRemaining,
    quotaExhausted,
    canSendMail,
    refetchCompanies: companyCx?.refetch,
  };
}
